import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'gwt/:callback',
  async getComponent (nextState) {
    const {
      default: GscContainer
    } = await import(/* webpackChunkName: "gsc" */ './containers/GscContainer.jsx')
      .catch(handleChunkLoadError);
    return GscContainer;
  }
});
